import React from "react";
import { motion } from "framer-motion";

function Features() {
  const features = [
    {
      title: "Smart Automation & Control Systems",
      description:
        "Implement intelligent automation solutions using PLCs, SCADA, and IoT technologies to improve operational efficiency, reduce downtime, and enhance production quality.",
      color: "#7AC943",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Robotics & Machine Integration",
      description:
        "Seamlessly integrate robotic systems into production lines for material handling, assembly, and packaging with precision and consistency.",
      color: "#3FA34D",
      animation: { x: 100, y: 0 }, // from right
    },
    {
      title: "Industrial IoT & Data Analytics",
      description:
        "Connect industrial equipment with IoT sensors to monitor real-time performance, predict maintenance needs, and optimize resource utilization.",
      color: "#00A7C4",
      animation: { x: 0, y: 100 }, // from bottom
    },
    {
      title: "Process Optimization",
      description:
        "Enhance production efficiency through automated monitoring, feedback control loops, and data-driven optimization of industrial processes.",
      color: "#0077B6",
      animation: { x: 0, y: -100 }, // from top
    },
    {
      title: "Energy Management Systems",
      description:
        "Reduce energy consumption and costs by deploying automated energy monitoring, control systems, and smart grid integrations.",
      color: "#FF9800",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Safety & Compliance Automation",
      description:
        "Ensure worker safety and regulatory compliance through automated safety interlocks, monitoring systems, and predictive risk assessment tools.",
      color: "#9C27B0",
      animation: { x: 100, y: 0 }, // from right
    },
  ];

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "28px",
      marginBottom: "30px",
      fontWeight: "bold",
      letterSpacing: "0px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      padding: "20px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "200px",
      cursor: "pointer",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#4b5563",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Industrial Automation Solutions</h2>
      <div style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ ...feature.animation, opacity: 0 }}
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.2 }} // triggers animation only when in view
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
